// extracted by mini-css-extract-plugin
export var numpadContainer = "_nj-1";
export var phoneButton = "_nj-0";